import React, { useEffect, useState } from "react";
import { Instagram, Heart, ExternalLink } from "lucide-react";
import api from "../lib/api";
import { EditableText } from "./live/Editable";

export default function InstagramFeed() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/instagram", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="kicker mb-3 flex items-center gap-2">
              <Instagram className="h-4 w-4" />
              <EditableText path="home.instagram.kicker" as="span">Follow us</EditableText>
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0B2A6B]">
              <EditableText path="home.instagram.heading" as="span">
                @kikicentre on Instagram
              </EditableText>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/kikicentre"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-500 text-white font-bold hover:opacity-90 transition shadow-lg"
            data-testid="instagram-view-profile-cta"
          >
            <Instagram className="h-5 w-5" /> View Profile on Instagram
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {items.map((p, i) => (
            <a
              key={p.id}
              href={p.post_url || "#"}
              target="_blank"
              rel="noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl bg-slate-100 animate-fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <img
                src={p.image_url}
                alt={p.caption}
                className="absolute inset-0 w-full h-full object-cover zoom-img"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80 opacity-0 group-hover:opacity-100 transition" />
              <div className="absolute inset-0 flex flex-col justify-between p-3 opacity-0 group-hover:opacity-100 transition">
                <div className="flex justify-end">
                  <Instagram className="h-5 w-5 text-white drop-shadow" />
                </div>
                <div>
                  <div className="flex items-center gap-1 text-white text-xs font-semibold mb-1">
                    <Heart className="h-3.5 w-3.5 fill-current" />
                    {p.likes}
                  </div>
                  <p className="text-[11px] text-white/90 line-clamp-2">{p.caption}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
